var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyCart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 67,
  height: 73,
  fill: "none",
  viewBox: "0 0 67 73"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M1.844.647A1.2 1.2 0 1 0 .87 2.842l7.583 3.36c.27.12.444.388.444.684V53.29a8.99 8.99 0 0 0 8.64 8.98 6.288 6.288 0 1 0 9.875.007h23.904a6.288 6.288 0 1 0 5.027-2.397l-.087-.003H17.886a6.587 6.587 0 0 1-6.588-6.587v-6.62a7.76 7.76 0 0 0 5.388 2.165h42.37c4.3 0 7.787-3.487 7.787-7.788V24.482a3.894 3.894 0 0 0-3.373-3.859l-52.171-7.041V6.886a3.15 3.15 0 0 0-1.872-2.877zm9.455 40.4V16.003l51.85 6.999c.74.1 1.293.732 1.293 1.48v16.565a5.387 5.387 0 0 1-5.387 5.388H16.686a5.387 5.387 0 0 1-5.387-5.388m11.173 29.009a3.888 3.888 0 1 0 0-7.776 3.888 3.888 0 0 0 0 7.776m37.673-3.888a3.888 3.888 0 1 1-7.776 0 3.888 3.888 0 0 1 7.776 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M40.07 37.745a1.2 1.2 0 0 1-1.2 1.2h-2a1.2 1.2 0 0 1 0-2.4h2a1.2 1.2 0 0 1 1.2 1.2M30.593 27.021a1.2 1.2 0 0 1 1.2 1.2v3.874a1.2 1.2 0 0 1-2.4 0v-3.874a1.2 1.2 0 0 1 1.2-1.2M45.142 27.021a1.2 1.2 0 0 1 1.2 1.2v3.874a1.2 1.2 0 0 1-2.4 0v-3.874a1.2 1.2 0 0 1 1.2-1.2",
  clipRule: "evenodd"
})));
export { SvgEmptyCart as ReactComponent };